class ProductFeedsProducts {
  constructor(appAPI, appUtils, productFeedsProductsListManager) {
    'inject';

    this._appAPI = appAPI;
    this._appUtils = appUtils;
    this._productFeedsProductsListManager = productFeedsProductsListManager;
  }
  formatProductCategories(categories) {
    return categories.map((category) => ({
      path: category.id,
      label: category.id,
      id: category.id,
      value: category.active === 1,
      type: {
        string: true,
        name: 'string',
      },
    }));
  }
  formatProductExtras(extras) {
    return this._injectPaths(extras.map((extra) => {
      const valueInfo = this._getValueInfo(extra.key_value);
      return {
        id: extra.key_name,
        label: extra.key_name,
        value: valueInfo.value,
        type: valueInfo.type,
        length: valueInfo.length,
        empty: valueInfo.empty,
      };
    }));
  }
  formatProductIds(ids) {
    return ids.map((info) => ({
      path: info.key,
      id: info.id,
      label: info.key,
      value: info.value,
      type: {
        string: true,
        name: 'string',
      },
    }));
  }
  formatProductSettings(settings) {
    const ids = Object.keys(settings);
    const last = ids.length - 1;
    return this._injectPaths(ids.reduce(
      (acc, id, index) => {
        const valueInfo = this._getValueInfo(settings[id]);
        const value = {
          id,
          label: id,
          value: valueInfo.value,
          type: valueInfo.type,
          length: valueInfo.length,
          empty: valueInfo.empty,
        };
        if (value.type.object) {
          acc.objects.push(value);
        } else {
          acc.common.push(value);
        }

        return index === last ?
          [
            ...acc.common.sort(this._appUtils.sortObjectsList('label')),
            ...acc.objects.sort(this._appUtils.sortObjectsList('label')),
          ] :
          acc;
      },
      {
        common: [],
        objects: [],
      },
    ));
  }
  formatSyndication(syndication) {
    return this._injectPaths(
      Object.keys(syndication).map((syndicationType) => ({
        type: {
          name: 'category',
          category: true,
        },
        id: syndicationType,
        label: syndicationType,
        empty: syndication[syndicationType].length === 0,
        value: syndication[syndicationType].map((item) => {
          const keys = Object.keys(item);
          const values = keys
          .filter((key) => key !== 'active')
          .map((key) => ({
            label: key,
            value: item[key],
          }));
          return {
            type: {
              name: 'object',
              object: true,
            },
            id: item.matching_value_sender + item.matching_value_receiver,
            label: '',
            length: Object.keys(item).length,
            empty: false,
            value: [
              {
                label: 'active',
                value: item.active === 1,
              },
              ...values,
            ],
          };
        }),
      }))
      .filter((item) => item.value.length > 0),
    );
  }
  getProductCategories(accountId, productId, format = true) {
    let result = this._appAPI.getProductFeedsProductCategories(accountId, productId)
    .then(({ categories }) => categories);
    if (format) {
      result = result.then((categories) => this.formatProductCategories(categories));
    }

    return result;
  }
  getProductExtract(accountId, productId) {
    return this._appAPI.getProductFeedsProductExtract(accountId, productId);
  }
  getProductExtras(accountId, productId, format = true) {
    let result = this._appAPI.getProductFeedsProductExtras(accountId, productId)
    .then(({ extras }) => extras);
    if (format) {
      result = result.then((extras) => this.formatProductExtras(extras));
    }

    return result;
  }
  getProductIds(accountId, productId, format = true) {
    let result = this._appAPI.getProductFeedsProductIds(accountId, productId)
    .then((response) => response.product_ids);
    if (format) {
      result = result.then((ids) => this.formatProductIds(ids));
    }

    return result;
  }
  getProductSettings(accountId, productId, format = true) {
    let result = this._appAPI.getProductFeedsProductSettings(accountId, productId);
    if (format) {
      result = result
      .then((settings) => this.formatProductSettings(settings));
    }

    return result;
  }
  getProductSyndication(accountId, productId, format = true) {
    let result = this._appAPI.getProductFeedsProductSyndication(accountId, productId);
    if (format) {
      result = result.then((syndication) => this.formatSyndication(syndication));
    }

    return result;
  }
  newList(accountId) {
    return this._productFeedsProductsListManager.newList(accountId);
  }
  _getValueInfo(original) {
    let value = original;
    const isArray = Array.isArray(value);
    const isObject = !isArray && value !== null && typeof value === 'object';
    const type = {
      name: '',
      array: false,
      object: false,
      string: false,
      category: false,
    };
    let length = null;
    let empty = false;
    if (isArray) {
      type.name = 'array';
      ({ length } = value);
      empty = length === 0;
    } else if (isObject) {
      type.name = 'object';
      const keys = Object.keys(value);
      ({ length } = keys);
      empty = length === 0;
      value = keys
      .map((key) => ({
        label: key,
        value: value[key],
      }))
      .sort(this._appUtils.sortObjectsList('name'));
    } else {
      type.name = 'string';
      type.string = true;
      if (value === null) {
        value = 'null';
      }
    }

    type[type.name] = true;

    return {
      type,
      value,
      length,
      empty,
    };
  }
  _injectPaths(settings, parentPath = '') {
    return settings.map((setting) => {
      const newSetting = Object.assign(
        {
          path: (parentPath ? `${parentPath}.${setting.id}` : setting.id),
        },
        setting,
      );

      if (newSetting.type.object || newSetting.type.array) {
        newSetting.value = newSetting.value.map((item) => Object.assign(
          {
            path: `${newSetting.path}.${item.label}`,
          },
          item,
        ));
      } else if (newSetting.type.category) {
        newSetting.value = this._injectPaths(
          newSetting.value,
          newSetting.path,
        );
      }

      return newSetting;
    });
  }
}

export { ProductFeedsProducts };
